import { Table, Input, CollapseProps, Collapse, Grid, Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { EnergyGlossaryBreadcrumb } from "../../../../../config/BreadcrumbConfig";

import { AppDispatch, RootState } from "../../../../../store/app";
import { useDispatch, useSelector } from "react-redux";
import { fetchAcronymDetails, fetchAcronyms } from "../Utils/slice";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import PageSpinner from "../../../../../components/PageSpinner/PageSpinner";
import CommonModal from "../../../../../components/Modals/CommonModal";
import "../../../../../assets/styles/custom/customStyles/cutomStyles.css";

/**
 * Renders component for All Careers .
 *
 * @return {JSX.Element} The rendered component.
 */
const Index = () => {
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const acronymsListAll = useSelector(
    (state: RootState) => state.WEBPROFILE.acronymsList
  );
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [acronymsList, setAcronymsList] = useState(acronymsListAll);
  const [inputValue, setInputValue] = useState("");

  const [detailsModalId, setDetailsModalId] = useState<any>(null);
  const translationLanguage = useSelector((state: RootState) => state.COMMON.translationLanguage);

  /* Modal */
  const [detailsModalData, setDetailsModalData] = useState<any>();
  const [detailsModalTitle, setDetailsModalTitle] = useState<any>();
  const [detailsModal, setDetailsModal] = useState<any>(false);
  const [defaultActive, setDefaultActive] = useState(["1", "2"]);

  /* Modal */

  useEffect(() => {
    setAcronymsList(acronymsListAll);
  }, [acronymsListAll]);

  useEffect(() => {
    setLoading(true);
    const timeoutId = setTimeout(() => {
      if (inputValue) {
        const filteredData = acronymsListAll.filter(
          (item: any) =>
            item.acronym.toLowerCase().includes(inputValue.toLowerCase()) ||
            item.title.toLowerCase().includes(inputValue.toLowerCase())
        );
        setAcronymsList(filteredData);
      } else {
        setAcronymsList(acronymsListAll);
      }
      setLoading(false);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [inputValue, acronymsListAll]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setLoading(true);
    dispatch(fetchAcronyms())
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (detailsModalId) {
      showCareerDetails(detailsModalId);
    } else {
      setDetailsModal(false);
      setTimeout(() => {
        setDetailsModalData(null);
        setDetailsModalTitle(null);
      }, 1000);
    }
  }, [detailsModalId]);

  const showCareerDetails = (acronym_id: any) => {
    dispatch(fetchAcronymDetails(acronym_id))
      .then((data: any) => {
        setDetailsModal(true);
        setDetailsModalData(data.data);
        setDetailsModalTitle(data.data.acronym);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const columns = [
    {
      title: (
        <span style={{ color: "#7B7D7D", fontSize: 14, fontFamily: "Poppins" }}>
          Acronym
        </span>
      ),
      dataIndex: "acronym",
      key: "acronym",
      width: "30%",
      render: (text: string) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: (
        <span style={{ color: "#7B7D7D", fontSize: 14, fontFamily: "Poppins" }}>
          Definition
        </span>
      ),
      dataIndex: "title",
      key: "title",
      width: "70%",
    },
  ];

  const getItems: () => CollapseProps["items"] = () => {
    return [
      {
        key: "1",
        label: (
          <div className="analystTitle">
            <h4>Title</h4>
          </div>
        ),
        children: (
          <div className="boxInnerContent">
            <div className="ant-row">
              <div
                className={
                  " ant-col-md-24 ant-col-sm-24 ant-col-xs-24 ant-col-xl-24 ant-col-lg-24"
                }
              >
                {detailsModalData?.title && (
                  <div className="cmsInnerContent">
                    {detailsModalData.title}
                  </div>
                )}
              </div>
            </div>
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div className="analystTitle">
            <h4>DESCRIPTION</h4>
          </div>
        ),
        children: (
          <div className="boxInnerContent">
            <div className="ant-row">
              <div
                className={
                  " ant-col-md-24 ant-col-sm-24 ant-col-xs-24 ant-col-xl-24 ant-col-lg-24"
                }
              >
                {detailsModalData?.description && (
                  <div
                    className="cmsInnerContent"
                    dangerouslySetInnerHTML={{
                      __html: detailsModalData.description,
                    }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        ),
      },
    ];
  };

  return !pageLoading ? (
    <div style={{ background: "#f5f6f7" }} className="all-careers-mobile">
      <section>
        <div className="container-fluid">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="career-index-header mobile-header">
                <div
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <BreadcrumbComponent
                    key={1}
                    items={EnergyGlossaryBreadcrumb.path}
                  />

                  <div
                    className="glossary-search-responsive"
                    style={{
                      width: "100%",
                      maxWidth: screens.md ? 480 : "100%",
                      marginLeft: screens.md ? "auto" : 0,
                      height: 48,
                    }}
                  >
                    <Input
                      allowClear
                      size="large"
                      // placeholder="Search"
                      className="notranslate"
                      placeholder={translationLanguage == "es" ? "La búsqueda solo funciona en inglés" : "Search"}
                      prefix={
                        <SearchOutlined
                          style={{ color: "#bdbdbd", fontSize: 18 }}
                        />
                      }
                      style={{
                        borderRadius: 10,
                        background: "#fff",
                        border: "none",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                        fontSize: 17,
                        paddingLeft: 12,
                        maxWidth: "100%",
                        height: "100%",
                        lineHeight: "48px", // 💡 Add this
                        display: "flex", // 💡 Add this
                        alignItems: "center", // 💡 And this
                      }}
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 17,
                    color: "#555",
                    // marginLeft: 5,
                    marginTop: 10,
                  }}
                >
                  The energy sector uses a wide range of specialized terms and
                  acronyms. This glossary helps you understand the language
                  behind today&rsquo;s most important technologies, careers, and
                  systems. Whether you&rsquo;re exploring a new field or
                  deepening your expertise, use this guide to decode key terms
                  across clean energy, fossil fuels, the grid, and beyond.
                </div>
              </div>

              <div
                className="glossary-search-mobile"
                style={{ display: "none", marginBottom: 16 }}
              >
                <Input
                  allowClear
                  size="large"
                  className="notranslate"
                  placeholder={translationLanguage == "es" ? "La búsqueda solo funciona en inglés" : "Search"}

                  // placeholder="Search"
                  prefix={
                    <SearchOutlined
                      style={{ color: "#bdbdbd", fontSize: 18 }}
                    />
                  }
                  style={{
                    borderRadius: 10,
                    background: "#fff",
                    border: "none",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
                    fontSize: 17,
                    paddingLeft: 12,
                    width: "100%",
                  }}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </div>
            </Col>
            <Col span={24}>
              <Table
                columns={columns}
                dataSource={Array.isArray(acronymsList) ? acronymsList : []}
                loading={loading}
                rowKey={(record, idx) =>
                  record &&
                  (record.id ||
                    (record.acronym && record.title
                      ? record.acronym + record.title
                      : idx))
                }
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: 20,
                  position: ["bottomCenter"],
                  onChange: (page) => {
                    setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }, 10);
                  }
                }}
                bordered={false}
                style={{ background: "#fff", borderRadius: 12, marginBottom: '3rem', paddingBottom: '2rem' }}
                scroll={{ x: 400 }}
                rowClassName={(_, idx) =>
                  idx % 2 === 1 ? "custom-table-row" : "custom-table-row-alt"
                }
                className="custom-glossary-table"
              />
            </Col>
            <CommonModal
              title={detailsModalTitle}
              open={detailsModal}
              onCancel={() => setDetailsModalId(null)}
              className="analystModal"
              width={1300}
            >
              <Collapse
                bordered={false}
                activeKey={defaultActive}
                expandIcon={({ isActive }) => (
                  <DownOutlined rotate={isActive ? 180 : 0} />
                )}
                expandIconPosition={"end"}
                onChange={(val: any) => {
                  setDefaultActive(val);
                }}
                items={getItems()}
              />
            </CommonModal>
          </Row>
        </div>
      </section>
    </div>
  ) : (
    <PageSpinner />
  );
};

export default Index;
